import { create } from "zustand";

export const appleModal = create((set) => ({
  openModal: false,

  setOpenModal: (data) => {
    set(() => ({ openModal: data }));
  },
}));
